module.exports = __webpack_public_path__ + "img/ic_pending.60e1ddd9.svg";